export enum EnumReducers {
  variantProduct = 'variantProduct',
  productSet = 'productSet',
  simpleProduct = 'simpleProduct',
}
